import { useMemo } from 'react';
import FlowCompetition from './FlowCompetition';
import CompetitionCardPath from './CompetitionCardPath';
import {
  Vector3,
  CurvePath,
  CatmullRomCurve3,
} from 'three';

export default function CompetitionPaths({ paths }) {
  const curves = useMemo(() => {
    const curves = new CurvePath();

    for (const line of paths) {
      const geo = line.geometry.attributes.position;
      const pts = [];
      for (let i = 0; i < geo.count; i++) {
        pts.push(new Vector3().fromBufferAttribute(geo, i));
      }

      curves.add(new CatmullRomCurve3(pts, false));
    }

    return curves;
  }, [paths]);

  return (
    <>
      <FlowCompetition
        curves={ curves }
      />
      <group name="Competition_Cards_Path">
        { paths.map((path, idx) => {
          return (
            <CompetitionCardPath
              key={ idx }
              index={ idx }
              curve={ curves.curves[idx] }
            />
          );
        }) }
      </group>
    </>
  );
};